import styled from 'styled-components';
import { Sizes } from '../../constants/sizes';
import { Device } from '../../constants/device';

type ContainerProps = {
  compact?: boolean;
}

export const Container = styled.div<ContainerProps>`
  margin: 0 auto;
  width: 100%;
  max-width: ${props => props.compact ? Sizes.ContainerCompactWidth : Sizes.ContainerBaseWidth}px;

  ${Device.upDesktop} {
    max-width: ${props => props.compact ? Sizes.ContainerCompactWidth : Sizes.ContainerLargeWidth}px;
  }

  ${Device.downTablet} {
    padding: 0 15px 100px;
  }

  flex: 1;
  display: flex;
  flex-direction: column;

  padding-bottom: 100px;
  padding-right: 30px;
  padding-left: 30px;
`;

Container.defaultProps = {
  compact: false
};
